module.exports = __webpack_public_path__ + "img/ann_d.82d0fc9d.png";